export default {"src":"/_next/static/media/united-kingdom.61b5eec8.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};